import React from 'react';
import { useSelector } from 'react-redux';
import { getRothBeneficiaryOption } from '../../../../redux/modules/rothConversionTransaction/rothConversionTransaction.selectors';
import { ROTH_CONVERSION_BENEFICIARY_OPTIONS_LABEL } from '../../../../settings/settings';
import If from '../../../Shared/If/If';
import StepCollapsed from '../../../Shared/StepCollapsed/StepCollapsed';

const BeneficiarySummary = ({ onEdit, step }) => {
  const beneficiaryOption = useSelector(getRothBeneficiaryOption);

  return (
    <If test={beneficiaryOption}>
      <StepCollapsed className="summary-display">
        <div className="summary-display">
          <div className="summary-display_fund-info">
            <span>
              {ROTH_CONVERSION_BENEFICIARY_OPTIONS_LABEL[beneficiaryOption]}
            </span>
            <a
              id={`rothconversion-step-${step}-edit`}
              className="rothconversion-summary-link"
              onClick={onEdit}
            >
              Edit
            </a>
          </div>
        </div>
      </StepCollapsed>
    </If>
  );
};

export default BeneficiarySummary;
